import React from "react";
import ChatLayout from "../layouts/dashboard/chat-layout";
import Chat from "../views/dashboard/app/chat";
import Protector from "../components/protector/Protector";
import Fbchat from "../views/dashboard/app/Fbchat";
import Wpchat from "../views/dashboard/app/Wpchat";
import Appprotector from "../components/protector/AppProtector";
import TgChat from "../views/dashboard/app/TgChat";
import AllChat from "../views/dashboard/app/allChat";

export const ChatRouter = [
  {
    path: "chat",
    element: <Protector Componet={ChatLayout} />,
    children: [
      {
        path: "Igchat",
        element: <Appprotector  Componet={Chat} />,
      },
      {
        path: "Fbchat",
        element: <Appprotector  Componet={Fbchat} />,
      },
      {
        path: "wpchat",
        element: <Appprotector  Componet={Wpchat} />,
      },
      {
        path: "inbox",
        element: <Protector  Componet={AllChat} />,
      },
      {
        path: "telegram-chat",
        element: <Appprotector  Componet={TgChat} />,
      },
    ],
  },
];
